import { IMAGES } from "@/site";
import { PageHero, Section, SectionTitle, BulletGrid, CTABand } from "@/components/ui-blocks/Blocks";

const SUPPORT = ["New driver training support","Driver refresher programs","Corrective training","Safety workshops","Pre-trip mastery programs","Driver evaluations","Driver readiness assessments","Training handouts","Digital learning resources","Future staffing support"];
const PROBLEMS = ["Driver shortages","Inconsistent training","Preventable accidents","Weak pre-trip inspection skills","Unsafe turning habits","Poor mirror use","Loading and unloading mistakes","Lack of refresher training","Drivers returning after absence","Gaps between classroom knowledge and real-world operation"];
const BENEFITS = ["Better prepared drivers","Stronger safety culture","More consistent training language","Reduced preventable incidents","Improved driver confidence","Additional support for supervisors","Reusable training materials","Professional development for current drivers","Future workforce development support"];

export default function ForDistricts() {
  return (
    <>
      <PageHero
        testid="districts-hero"
        eyebrow="For Districts"
        title="Support for transportation departments."
        description="CLB Solution is being built to support transportation departments, school districts, and contractors through safety-focused training support, driver development, and future workforce solutions."
        image={IMAGES.heroHome}
      />

      <Section testid="districts-support">
        <SectionTitle eyebrow="District Support May Include" title="A practical menu of training partnership options." />
        <BulletGrid items={SUPPORT} testid="districts-support-grid" />
      </Section>

      <Section className="bg-[#0c0c0e] border-y border-white/10" testid="districts-problems">
        <SectionTitle eyebrow="Problems CLB Solution Can Help Address" title="Where structured training makes the biggest difference." />
        <BulletGrid items={PROBLEMS} testid="districts-problems-grid" />
      </Section>

      <Section testid="districts-benefits">
        <SectionTitle eyebrow="Benefits" title="What partnership can mean for your department." />
        <BulletGrid items={BENEFITS} testid="districts-benefits-grid" />
      </Section>

      <CTABand title="Build a stronger transportation team." description="Email CLB Solution to discuss district-specific training support, refresher programs, or workforce development." />
    </>
  );
}
